import { Button, Modal } from '@warp-ds/react';
import { SanitizedText } from '@finn-no/tjt-common-components';
import { useState } from 'react';
import IconInfo16 from '@warp-ds/icons/react/info-16';
import IconShipping24 from '@warp-ds/icons/react/shipping-24';
import { Fees, PriceEstimateType } from '../../../types/uiTypes';

const getOrderLines = (orderLines: Fees) => {
    const { total, ...otherFees } = orderLines;
    return {
        total,
        fees: Object.values(otherFees),
    };
};

const PriceEstimate = ({
    priceEstimate,
    buttonText,
}: {
    priceEstimate: PriceEstimateType;
    buttonText: string;
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { fees, total } = getOrderLines(priceEstimate.fees);
    return (
        <>
            <Button
                link
                onClick={() => setIsOpen(true)}
                className="font-bold flex! items-center pl-0 text-left mb-16 mt-6 md:my-12"
            >
                <SanitizedText text={buttonText} as="span" />
                <IconInfo16 className="ml-6" />
            </Button>
            <Modal
                open={isOpen}
                onDismiss={() => setIsOpen(false)}
                right
                title={
                    <h1 className="h4 sm:h3 flex items-center mb-0">
                        <IconShipping24 className="mr-8" color="var(--w-s-color-text-subtle)" />{' '}
                        {priceEstimate.serviceInfo.title}
                    </h1>
                }
            >
                <div>
                    <ul className="border-b pb-8 mb-16 text-s">
                        {priceEstimate.serviceInfo.details.map((detail, i) => (
                            <li className="tjt-li-with-dot relative pl-16 mb-8" key={i}>
                                {detail.title}
                            </li>
                        ))}
                    </ul>
                    {fees.map((fee) => (
                        <div key={fee.text} className="flex justify-between my-8 text-m">
                            <dt className="m-0">{fee.text}</dt>
                            <SanitizedText text={fee.amountString} className="m-0" />
                        </div>
                    ))}
                    <div className="flex justify-between mt-8 font-bold">
                        <dt className="m-0">{total.text}</dt>
                        <dd className="m-0">{total.amountString}</dd>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default PriceEstimate;
